import { authSplitApi } from 'redux/helpers/slice.helpers';
import { currentAmplifyAuthUser } from 'api/sevices/authServices';
import { TAmplifyError } from 'data/types/Amplify.types';

export const AuthAmplify = authSplitApi('amplify').injectEndpoints({
  endpoints: build => ({
    currentAuthenticatedUserAmplify: build.query<null, boolean>({
      // @ts-ignore
      async queryFn() {
        try {
          const user = await currentAmplifyAuthUser();
          return { data: user.attributes };
        } catch (e) {
          const error = e as TAmplifyError;
          return {
            error: {
              data: {
                name: error.name,
                code: error.code,
                message: error.message,
              },
              status: error.code,
            },
          };
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useCurrentAuthenticatedUserAmplifyQuery } = AuthAmplify;
